import styled from 'styled-components'

const Unread = styled.span`
    background: #f84f7f;
    font-size: 10px;
    border-radius: 50%;
    height: 22px;
    text-align: center;
    line-height: 22px;
    padding: 0px 6px;
    font-weight: 600;
    color: #FFF;
    display: inline-block;
    position: absolute;
    top: 1px;
    right: 15px;
    min-width: 22px;
`

export {
    Unread,
}